import {
  LayoutNodeType,
  LayoutNodeActionType,
  LayoutNodeFilterType,
} from "@towersystems/roam-common/lib/generated-types";

export const quickKeyTypes = [
  {
    label: "Filters",
    typeListItems: [
      LayoutNodeType.PRODUCT,
      LayoutNodeFilterType.CATEGORY,
      LayoutNodeFilterType.DEPARTMENT,
    ],
  },
  {
    label: "Sale",
    typeListItems: [
      LayoutNodeActionType.PARK_SALE,
      LayoutNodeActionType.SWITCH_SALE,
      LayoutNodeActionType.ADD_NOTE_TO_SALE,
      LayoutNodeActionType.CANCEL_SALE,
      LayoutNodeActionType.DISCOUNT_SALE,
      LayoutNodeActionType.APPLY_SALE_TRADE_PRICE,
    ],
  },
  {
    label: "Customer",
    typeListItems: [
      LayoutNodeActionType.ADD_CUSTOMER,
      LayoutNodeActionType.APPLY_CUSTOMER_LOYALTY_POINTS,
    ],
  },
];
